import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCookies } from '@shared/hooks';

export const Subscribe = () => {
  const navigate = useNavigate();
  const { code, hash, id } = useParams<{ code: string; hash: string; id: string }>();

  const { getCookie, setCookie } = useCookies();

  const hashCode = getCookie('subscribe_hash');

  React.useEffect(() => {
    const subscribe = () => {
      if (hash) {
        setCookie('subscribe_hash', JSON.stringify({ hashCode: hash, program: id }));
      }
      navigate(`/programs/${code}/program/${id}`);
    };

    if (hash) subscribe();
  }, [hash, id, code, navigate, hashCode]);

  return <></>;
};

export default Subscribe;
